// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"3dc5bc80","453":"f72ff5ec","772":"6db083a0","807":"456949fd","861":"6ded14b1"}[chunkId] + ".chunk.js";
};